import { render } from "./PregnancySettingsView.vue?vue&type=template&id=48653788&scoped=true"
import script from "./PregnancySettingsView.vue?vue&type=script&lang=js"
export * from "./PregnancySettingsView.vue?vue&type=script&lang=js"

import "./PregnancySettingsView.vue?vue&type=style&index=0&id=48653788&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48653788"]])

export default __exports__